module.exports = __webpack_public_path__ + "img/7.0ff682a2.webp";